<template>
  <!-- 管理端首页 -->
  <div class="height100">
    <el-container>
      <el-header style="height: auto; padding: 0">
        <Head></Head>
        <Tabs></Tabs>
      </el-header>
      <el-container>
        <el-aside width="210px">
          <LeftMenu></LeftMenu>
        </el-aside>
        <el-main> <router-view /></el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>

import LeftMenu from '../layout/leftMenu'
import Tabs from '../layout/managetabs'
import Head from '../layout/head'
export default {
  name: 'Home',
  data () {
    return {
      loginForm: {
        userName: '',
        password: ''
      },
      rules: {
        userName: []
      }
    }
  },
  components: {
    Tabs,
    LeftMenu,
    Head
  },
  methods: {}
}
</script>

<style lang="scss">
.bottomc {
  height: calc(100% - 56px);
}
.height100 {
  height: 100%;
}
.aside {
  width: auto !important;
}
.noheight {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/index.vue